import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  note: {
    backgroundColor: designTokens.primary[50],
    border: `1px solid ${designTokens.primary[100]}`,
    borderLeft: `3px solid ${designTokens.accent[500]}`,
    borderRadius: designTokens.borderRadius.md,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.primary[700],
    lineHeight: String(designTokens.lineHeight.relaxed),
    "& strong": {
      color: designTokens.primary[900],
      fontWeight: designTokens.fontWeight.semibold,
    },
  },
});
